"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsplashImageTab = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BetterInfiniteScroll_1 = require("Project/ContentSidebar/Images/BetterInfiniteScroll/BetterInfiniteScroll");
var Types_1 = require("Project/ContentSidebar/Types");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var ExploreEmptyState_1 = require("../../SharedComponents/ExploreEmptyState");
var SidebarExplore_1 = require("../../SidebarExplore");
var SidebarExploreContext_1 = require("../../SidebarExploreContext");
var UnsplashImageCard_1 = __importDefault(require("./UnsplashImageCard"));
var styles = __importStar(require("./UnsplashImageTab.css"));
exports.UnsplashImageTab = (0, mobx_react_1.observer)(function (_a) {
    var onClickToAdd = _a.onClickToAdd, onDragAssetStart = _a.onDragAssetStart, onDragAssetEnd = _a.onDragAssetEnd, collectionId = _a.collectionId, collectionName = _a.collectionName, returnToCollectionsView = _a.returnToCollectionsView, headerRef = _a.headerRef, showError = _a.showError;
    var _b = (0, SidebarExploreContext_1.useSidebarExploreContext)(), unsplashImageStore = _b.unsplashImageDataStore, searchTerm = _b.searchTerm;
    var elementId = "image-tab-panel-image-scroll-container";
    var _c = __read((0, react_1.useState)("collection"), 2), mode = _c[0], setMode = _c[1];
    (0, react_1.useEffect)(function () {
        if (!!searchTerm) {
            setMode("search");
        }
        else {
            setMode("collection");
        }
    }, [searchTerm]);
    (0, react_1.useEffect)(function () {
        return function () {
            unsplashImageStore.reset();
        };
    }, [unsplashImageStore]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles.collectionImagesHeader, ref: headerRef },
            react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.backButton, icon: react_1.default.createElement(icons_1.ArrowLeft, null), tooltip: { content: "Back to collections" }, onClick: returnToCollectionsView }),
            react_1.default.createElement("div", { className: styles.collectionLabel }, mode === "collection" ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icons_1.Unsplash, { color: "active", size: icons_1.IconSize.Medium }),
                react_1.default.createElement(kaleidoscope_1.Label, { size: "m" }, collectionName))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Label, { size: "m" }, "Search results"))))),
        !unsplashImageStore.isLoadingData && unsplashImageStore.loadedAssets.length === 0 ? (react_1.default.createElement(ExploreEmptyState_1.ExploreEmptyState, { searchTerm: searchTerm, assetType: Types_1.AssetType.UnsplashImage })) : (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { id: elementId, className: styles.scrollContainer },
                react_1.default.createElement(BetterInfiniteScroll_1.BetterInfiniteScroll, { next: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 6, , 7]);
                                    if (!!!searchTerm) return [3, 2];
                                    return [4, unsplashImageStore.fetchNextIncrement("search", searchTerm)];
                                case 1:
                                    _a.sent();
                                    return [3, 5];
                                case 2:
                                    if (!collectionId) return [3, 4];
                                    return [4, unsplashImageStore.fetchNextIncrement("collection", collectionId)];
                                case 3:
                                    _a.sent();
                                    return [3, 5];
                                case 4:
                                    returnToCollectionsView();
                                    _a.label = 5;
                                case 5: return [3, 7];
                                case 6:
                                    error_1 = _a.sent();
                                    console.error(error_1);
                                    showError();
                                    return [3, 7];
                                case 7: return [2];
                            }
                        });
                    }); }, hasMore: unsplashImageStore.hasUnloadedAssets, loader: react_1.default.createElement(kaleidoscope_1.Stack, { padding: "s" },
                        react_1.default.createElement(kaleidoscope_1.Spinner, null)), dataLength: unsplashImageStore.loadedAssets.length, scrollableTarget: elementId, style: { overflow: "initial" } }, react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.grid }, unsplashImageStore.loadedAssets.map(function (asset, index) { return (react_1.default.createElement(UnsplashImageCard_1.default, { key: index, asset: asset, onClick: function () {
                        onClickToAdd(asset, { tab: SidebarExplore_1.SidebarExploreTab.Images, withSearchTerm: !!searchTerm });
                    }, onDragStart: function () {
                        onDragAssetStart(asset, { tab: SidebarExplore_1.SidebarExploreTab.Images, withSearchTerm: !!searchTerm });
                    }, onDragEnd: function () {
                        onDragAssetEnd(asset);
                    } })); }))))))));
});
